import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';

function BayiSearch({ setModel, value, searchParam }) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;
    const [search, setSearchBayi] = React.useState('');

    React.useEffect(() => {
        let active = true;
        if (search.length > 0 && open) {
            axios.get('/GetArtemisDealers/' + search.toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    if (active) {
                        if (res.data.length > 0) {
                            setOptions(res.data);
                        } else {
                            setOptions([]);
                        }
                    }
                });
        }
        return () => {
            active = false;
        };
    }, [search, open, loading]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setSearchBayi(searchParam);
        }
    }, [searchParam]);

    const updateModel = model => {
        setModel(model);
        value.ACIKLAMA = model.BAYI_ACIKLAMA;
        value.KUL_BAYI_KODU = model.KUL_BAYI_KODU;
        value.BAYI_KODU = model.BAYI_KODU;
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={open}
            value={value}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionLabel={(option) => { return option.KUL_BAYI_KODU + ' - ' + option.ACIKLAMA }}
            options={options}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => { setSearchBayi(e.target.value) }}
                    variant="outlined"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            filterOptions={(options, state) => options}
            loading={loading}
            onChange={(event, newValue) => {
                if (newValue && newValue.ACIKLAMA) {
                    updateModel(newValue);
                }
            }}
            
        />
    );
}

export default BayiSearch;
